//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  //    metaInfo: {
  //      title: '商品详情'
  //    },
  created: async function () {
    await this.getInfo();
  },
  data() {
    return {
      goodsId: this.params.goodsId,
      info: {}
    };
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/gooddetail/page.vue